import { useState } from "react";
import { Link } from "react-router-dom";
import Logo from "../assests/unitedLogo.png";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <nav className="fixed top-0 left-0 w-full bg-white shadow-md z-50 border-b border-gray-200">
      <div className="max-w-7xl mx-auto px-4 lg:py-2 py-2">
        <div className="flex items-center justify-between h-16 lg:h-20">

          {/* Logo */}
          <Link to="/" className="flex items-center gap-3">
            <img
              src={Logo}
              alt="We United Constructions"
              className="lg:h-24 h-20 w-auto object-contain"
            />
          </Link>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8">
            <NavLink title="Home" link="/" />
            <NavLink title="About" link="/about" />
            <NavLink title="Services" link="/services" />
            <NavLink title="Contact" link="/contact" />

            {/* CTA Button */}
            <Link
              to="/contact"
              className="ml-4 px-5 py-2 rounded-md bg-[#F57C00] text-white font-semibold hover:bg-[#e36f00] transition"
            >
              Get Quote
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden text-[#0B3C8A] focus:outline-none"
          >
            <svg
              className="w-8 h-8"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              {isOpen ? (
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              ) : (
                <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
              )}
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden bg-white border-t shadow-lg">
          <MobileLink title="Home" link="/" setIsOpen={setIsOpen} />
          <MobileLink title="About" link="/about" setIsOpen={setIsOpen} />
          <MobileLink title="Services" link="/services" setIsOpen={setIsOpen} />
          <MobileLink title="Contact" link="/contact" setIsOpen={setIsOpen} />

          <div className="px-6 pb-4">
            <Link
              to="/contact"
              onClick={() => setIsOpen(false)}
              className="block w-full text-center py-3 rounded-md bg-[#F57C00] text-white font-semibold"
            >
              Get Quote
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

/* Desktop Link */
const NavLink = ({ title, link }) => (
  <Link
    to={link}
    className="relative text-[#082C5A] font-medium transition hover:text-[#F57C00]
               after:absolute after:left-0 after:-bottom-1 after:h-[2px] after:w-0
               after:bg-[#F57C00] after:transition-all after:duration-300
               hover:after:w-full"
  >
    {title}
  </Link>
);

/* Mobile Link */
const MobileLink = ({ title, link, setIsOpen }) => (
  <Link
    to={link}
    onClick={() => setIsOpen(false)}
    className="block px-6 py-4 text-[#082C5A] font-medium hover:bg-gray-100 transition"
  >
    {title}
  </Link>
);

export default Navbar;
